import es from './es/index.js'
import en from './en/index.js'

export default {
  es,
  en
}
